import { Component, ChangeDetectionStrategy, input, output, signal, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';

@Component({
  selector: 'app-image-cropper-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DialogModule, ImageCropperComponent, ButtonComponent],
  templateUrl: './image-cropper-dialog.component.html',
  styleUrls: ['./image-cropper-dialog.component.scss'],
})
export class ImageCropperDialogComponent {
  readonly isVisible = input<boolean>(false);
  @Input() imageBase64: string | undefined;

  readonly onConfirm = output<string>();
  readonly onCancel = output<void>();

  protected readonly croppedImage = signal<string | undefined>(undefined);

  protected onImageCropped(event: any): void {
    this.croppedImage.set(event.base64 as string);
  }

  protected onCropperReady(): void {}

  protected confirmCrop(): void {
    const cropped = this.croppedImage();
    if (cropped) {
      this.onConfirm.emit(cropped);
      this.reset();
    } else if (this.imageBase64) {
      this.generateAutoCrop90(this.imageBase64).then(auto => {
        this.onConfirm.emit(auto);
        this.reset();
      });
    }
  }

  protected cancelCrop(): void {
    this.onCancel.emit();
    this.reset();
  }

  private reset(): void {
    this.croppedImage.set(undefined);
  }

  private generateAutoCrop90(base64: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const size = 128;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          if (!ctx) return reject('Canvas not supported');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, size, size);
          const ratio = Math.max(size / img.width, size / img.height);
          const drawWidth = img.width * ratio;
          const drawHeight = img.height * ratio;
          ctx.drawImage(img, (size - drawWidth) / 2, (size - drawHeight) / 2, drawWidth, drawHeight);
          resolve(canvas.toDataURL('image/png'));
        } catch (err) { reject(err); }
      };
      img.onerror = (e) => reject(e);
      img.src = base64;
    });
  }
}
